import { Stack, styled as styledMUI } from '@mui/material';
import InstaIcon from 'assets/logo_icon.svg';
import LunaIcon from 'assets/luna/LogoIcon.svg';
import { PARTNER } from 'partner_configuration/config';
import { TProps_InstaSpinner } from 'typings/componentTypes';
import { getPartnerId } from 'utils/commonFunctions';

const Spinner = styledMUI('div')(({ theme }) => ({
  '@keyframes interlaced': {
    '100%': {
      transform: 'rotate(1turn)'
    }
  },
  width: '100px',
  aspectRatio: 1,
  display: 'grid',
  color: theme.palette.primary.main,
  border: `4px solid transparent`,
  borderRadius: '50%',
  borderRightColor: theme.palette.primary.main,
  animation: 'interlaced 1s infinite linear',

  '&::before, &::after': {
    content: '""',
    gridArea: '1/1',
    margin: '8px',
    border: 'inherit',
    borderRadius: '50%',
    animation: 'interlaced 2s infinite'
  },
  '&::after': {
    margin: '2px',
    animationDuration: '3s'
  }
}));

const getIcon = (partnerName: string) => {
  switch (partnerName) {
    case PARTNER.LUNA:
      return LunaIcon;
    case PARTNER.INSTAVIEW:
    default:
      return InstaIcon;
  }
};

function InstaSpinner({ withWrapper = false }: TProps_InstaSpinner) {
  const partnerName = getPartnerId();

  return (
    <Stack
      display="-webkit-box !important"
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        height: withWrapper ? '60vh' : '100%',
        justifyContent: withWrapper ? 'center' : 'unset'
      }}
    >
      <Spinner />
      <img
        src={getIcon(partnerName)}
        alt="loader_icon"
        width="40px"
        height="40px"
        style={{
          marginLeft: -70.25
        }}
      />
    </Stack>
  );
}
export default InstaSpinner;
